<template>
    <div class="supplier-info">
        <strong v-if="!qualificationList.length">商品资质已存在，无需填写</strong>
        <!-- 商品检测报告 不需要校验 -->
        <template v-else>
            <div
                v-for="(qualification, idx) in qualificationList"
                :key="idx"
            >
                <xx-form
                    :ref="`form-${idx}`"
                    :model="qualification"
                    label-width="130px"
                    label-suffix="："
                    class="max-width-750 w-full"
                >
                    <p class="view-standard">
                        <!-- 去查看的地址是后端接口返回的 -->
                        不清楚资质填写标准？
                        <xx-link :path="qualificationSupportUrl">
                            去查看
                        </xx-link>
                    </p>
                    <qualification-status
                        :manufacturer-id="qualification.manufacturerId"
                        :manufacturer-name="qualification.manufacturerName"
                    />
                    <template v-if="qualification.existed">
                        资质已存在
                    </template>
                    <template v-else>
                        <xx-form-item
                            v-for="(qItem, index) in qualification.items"
                            :key="qItem.qualificationType + '-' + index"
                            :label="qualificationTypesMap[qItem.qualificationType]"
                            class="is-required"
                        >
                            <qualification-item
                                :p-idx="idx"
                                :item="qItem"
                                :index="index"
                                :need-valid="true"
                                :is-import-flag="isImportFlag"
                                :disabled-ids="getItemDisabledIds(qualification, qItem)"
                                :qualification-cert-list="qualificationCertList"
                                @remove="itemIdx => removeQualificationItem(idx, itemIdx)"
                            />
                        </xx-form-item>
                        <!-- 添加新的资质类型按钮 -->
                        <mc-button
                            class="btn-demo-item"
                            @click="addQualificationItem(idx)"
                        >
                            + 添加新的资质类型
                        </mc-button>
                    </template>
                </xx-form>
            </div>
        </template>
    </div>
</template>

<script>
import emitter from 'utils/emitter';
import { reportMetric } from 'utils/reportMetric';
import { hPost } from '@mcfe/tools';
import { createNewToken, supplierInfoToken } from '../shareState';
import { getBaseModel } from '../baseModel';
import QualificationItem from './item';
import QualificationStatus from '../../qualificationStatus';
import { CREATE_NEW_PRODUCT_STEP_NAMES, CREATE_NEW_PRODUCT_STEP } from '../config';

const baseModel = getBaseModel();

// 非进口资质
const unImportQualificatesTmp = () => [
    {
        qualificationType: 14,
        pictures: [],
        rejectedDisabledAttr: 'qualificationPhysicalPic',
        desc: '上传在售商品的全部可视面照片，且标签上的文字、图标均清晰可识别',
    },
    {
        idNumber: '',
        qualificationType: 13,
        longTerm: false,
        validTimeStart: -1,
        validTimeEnd: -1,
        pictures: [],
        rejectedDisabledAttr: 'qualificationInspectionReport',
        desc: '<span>1、第三方检测报告须含CMA章且完整、在效期内，与新建品匹配，标称生产单位与绑定生产商匹配</span><br/><span>2、快检报告完整、在效期内，与新建品匹配，与绑定供应商匹配</span>',
    },
];

// 进口资质字段
const importQualificatesTmp = () => [
    {
        qualificationType: 14,
        pictures: [],
        rejectedDisabledAttr: 'qualificationPhysicalPic',
        desc: '上传在售商品的全部可视面照片，且标签上的文字、图标均清晰可识别',
    },
    {
        idNumber: '',
        qualificationType: 15,
        longTerm: false,
        validTimeStart: -1,
        validTimeEnd: -1,
        pictures: [],
        rejectedDisabledAttr: 'qualificationDeclaration',
        desc: '报关单与入境检验检疫证明为一组同批次商品资质，包含新建品且在有效期内',
    },
    {
        idNumber: '',
        qualificationType: 16,
        longTerm: false,
        validTimeStart: -1,
        validTimeEnd: -1,
        pictures: [],
        rejectedDisabledAttr: 'qualificationEntryQuarantineCertificate',
        desc: '报关单与入境检验检疫证明为一组同批次商品资质，包含新建品且在有效期内',
    },
];

const qualificationTypeMap = {
    13: '商品检测报告',
    14: '商品包装及标签照片',
    15: '报关单',
    16: '入境检验检疫证明',
};
const descMap = {
    18: '<span>1、授权链条要完整, 从标签所示的生产商或委托商至我司供应商，每一环不可缺失，例如：A（生厂商或委托商）授权B（代理商），B授权C（我司供应商），则需提供A->B、B->C的销售授权书。</span><br/><span>2、授权书的内容（包括但不限于授权者、授权品牌、授权渠道等）需要与该商品的相关销售信息一致。</span><br/><span>3、有效期以授权书上规定为准。</span><br/><span>4、若资质为复印件,需要加盖我司供应商的鲜章。</span>',
    1: '<span>1、以营业执照上规定填写效期；若无截止日期则为长期有效。</span><br/><span>2、若资质为复印件，需要加盖我司供应商的鲜章。</span>',
    6: '<span>1、生产许可证编号与产品标签上标示一致。</span><br/><span>2、需上传生产许可证明细页且上传完整，生产类型包含所售商品。</span><br/><span>3、以生产许可证规定填写效期。</span><br/><span>4、若资质为复印件，需要加盖我司供应商的鲜章。</span>',
    24: '<span>1、需提交所有含“®”和“TM”商标的商标注册证或商标注册申请受理通知书。</span><br/><span>2、商标注册证有效期以证书上规定为准商标注册申请受理通知书的截止日期为签发日期➕2年。</span><br/><span>3、商标注册证要传全, 若有转让、续期或附页, 需同时上传, 不可少页。</span><br/><span>4、商标注册证或商标注册申请受理通知书的核定使用商品需要涵盖提报的产品类别。</span><br/><span>5、若资质为复印件,需要加盖我司供应商的鲜章。</span>',
};
const defaultDesc = '<span>1、资质要上传完整，不得缺页、漏页。</span><br/><span>2、若资质为复印件，需要加盖我司供应商的鲜章。</span><br/><span>3、有效期以资质上规定为准。</span>';
const FROM_SUPPLIER = 1; // 从供应商获取
const FROM_MANUFACTURER = 2; // 从生产商获取
const FROM_SKU = 3; // 从sku中获取
const MIN_VALID_LICENSE_TYPE = 0;// 其他资质类型禁用
export default {
    name: supplierInfoToken,
    components: {
        QualificationItem,
        QualificationStatus,
    },
    mixins: [emitter],
    props: {
        createProductType: {
            type: String,
            default: '新建品',
        },
    },
    data() {
        return {
            config: [],
            qualificationList: [], // 各供应生产商模型
            models: {}, // 前3个tab的数据
            hasQualification: false, // 供应商生产商已有资质，则不需要填写资质
            qualificationTypeMap,
            qualificationSupportUrl: '',
            qualificationCertList: [], // 证书类型
        };
    },
    computed: {
        // 后台类目
        bgCategoryId() {
            return this.createInfoModel?.bgCategoryId || null;
        },
        qualificationTypesMap() {
            const importQualificationTypeMap = {
                14: '商品包装及标签照片',
                15: '报关单',
                16: '入境检验检疫证明',
            };
            const unImportQualificationTypeMap = {
                13: '商品检测报告',
                14: '商品包装及标签照片',
            };
            const baseMap = this.isImportFlag ? importQualificationTypeMap : unImportQualificationTypeMap;

            // 动态添加 qualificationCertList 中的资质类型映射
            const dynamicMap = {};
            (this.qualificationCertList || []).forEach((cert) => {
                dynamicMap[cert.value] = cert.label;
            });

            // 合并固定映射和动态映射，固定映射优先级更高
            return { ...dynamicMap, ...baseMap };
        },
        // 提报信息数据
        createInfoModel() {
            return this.models.applyInfoSection || {};
        },
        // citysSku() {
        //     return this.createInfoModel.cityIds;
        // },
        // 获取当前提报城市的加工状态
        currentCitySkuType() {
            return this.createInfoModel.skuType;
        },
        // 当前提报城市的加工状态：原料/成品
        isMaterialOrFinished() {
            return this.currentCitySkuType === 1 || this.currentCitySkuType === 2;
        },
        // 基础信息
        baseInfoModel() {
            return this.models.skuBaseSection || {};
        },
        // 是否进口
        isImportFlag() {
            return +this.baseInfoModel.importFlag === 1;
        },
    },
    created() {
        baseModel.registerVM(this, supplierInfoToken);
    },
    async activated() {
        this.handlePagesWhetherPages();
        await this.initState();
        this.dispatch(createNewToken, 'page-loaded', true);
        this.getMisRequiredAndDefaultSkuType();
    },
    methods: {
        handlePagesWhetherPages() {
            reportMetric('supplier_createNewProduct_current_step_whether_render_or_not', 1, {
                createNewProductStepName: CREATE_NEW_PRODUCT_STEP_NAMES[CREATE_NEW_PRODUCT_STEP.SUPPLIER_INFO],
                createProductType: this.createProductType,
                presetSkuId: baseModel.models.presetSkuId,
                currentStep: CREATE_NEW_PRODUCT_STEP.SUPPLIER_INFO,
            });
        },
        getItemDisabledIds(qualification, qItem) {
            // 收集所有已选类型，排除当前项
            return qualification.items
                .map((item) => item.qualificationType)
                .filter((type) => type && type !== qItem.qualificationType);
        },
        async fetchQualificationCertList() {
            const params = {
                sourceList: [FROM_SUPPLIER, FROM_MANUFACTURER, FROM_SKU],
                isImport: this.isImportFlag,
            };
            const res = await hPost('/api/vss/shepherd/product/bizcenter/LicenseTypeTService/queryLicenseTypes', params);
            this.qualificationCertList = (res || [])
                .filter((item) => item.licenseType > MIN_VALID_LICENSE_TYPE)
                .map((item) => ({
                    label: item.name,
                    value: item.licenseType,
                    desc: descMap[item.licenseType] || defaultDesc,
                }));
        },
        // 添加新的资质类型
        addQualificationItem(idx) {
            this.qualificationList[idx].items.push({
                qualificationType: '', // 新增时为空，用户选择
                longTerm: false,
                validTimeStart: null,
                validTimeEnd: null,
                pictures: [],
                idNumber: '',
            });
        },
        // 删除添加的资质类型
        removeQualificationItem(idx, itemIdx) {
            this.qualificationList[idx].items.splice(itemIdx, 1);
        },
        async initState() {
            try {
                // 进入第四步，直接重新请求，这样可以避免一些不必要的判断，简化数据流
                const draft = await this.fetchNewCreateData(baseModel.models.applyId);
                baseModel.setData(draft);
                const supplierInfo = baseModel.initSupplierInfo;

                this.models = baseModel.data;
                const citySaleInfoList = ((this.models.citySkuManageSection || {}).citySkuManageInfo || []);

                // 根据经营城市的 供应商和生产商 计算出有几个不同的 资质
                // 如果接口存在数据，则进行一次merge
                // 如果销售城市有变动，则后续内容重置，简单处理
                this.qualificationList = this.genQualificationList(citySaleInfoList);

                // 详情数据回显的填充
                if (supplierInfo && supplierInfo.length) {
                    this.qualificationList.forEach((qItem) => {
                        supplierInfo.some((info) => {
                        // 通过供应商+生产商，唯一确定资质
                            if (qItem.manufacturerId === info.manufacturerId) {
                                if (info.items) {
                                // 处理模板中的固定资质类型
                                    const processedTemplateItems = qItem.items.map((tmpItem) => {
                                    // 从接口资质数据中找与模板资质类型相同的数据，如果没有则使用默认的模板资质数据 tmpItem
                                        let resObj = info.items.find((i) => i.qualificationType === tmpItem.qualificationType);
                                        if (resObj) {
                                        // 补充关键字段
                                            resObj.rejectedDisabledAttr = tmpItem.rejectedDisabledAttr || null;
                                            resObj.pictures = resObj.pictures || []; // 防止未Null
                                            resObj.desc = tmpItem.desc;
                                        } else {
                                            resObj = tmpItem;
                                        }
                                        return resObj;
                                    });

                                    // 找出接口返回的额外资质类型（不在模板中的动态添加的资质）
                                    const templateQualificationTypes = qItem.items.map((item) => item.qualificationType);
                                    const extraItems = info.items.filter((item) => !templateQualificationTypes.includes(item.qualificationType)).map((item) => ({
                                        ...item,
                                        pictures: item.pictures || [],
                                        desc: '',
                                        rejectedDisabledAttr: null, // 为动态资质设置 rejectedDisabledAttr，使其不受白名单限制
                                    }));

                                    // 合并模板资质和额外的动态资质
                                    qItem.items = [...processedTemplateItems, ...extraItems];
                                }
                                return true;
                            }
                            return false;
                        });
                    });
                    this.handlePagesRenderMetrics(1);
                }
            } catch (error) {
                this.handlePagesRenderMetrics(0);
                this.$message.error(error);
            }

            await this.fetchQualificationCertList();
        },
        handlePagesRenderMetrics(value = 1) {
            this.$nextTick(() => {
                reportMetric('supplier_create_newProduct_pages_render_success', value, {
                    createNewProductStepName: CREATE_NEW_PRODUCT_STEP_NAMES[CREATE_NEW_PRODUCT_STEP.SUPPLIER_INFO],
                    createProductType: this.createProductType,
                    presetSkuId: baseModel.models.presetSkuId,
                    currentStep: CREATE_NEW_PRODUCT_STEP.SUPPLIER_INFO,
                    value,
                });
            });
        },
        async fetchNewCreateData(applyId) {
            const draftData = await this.$service.fetchNewSellDetail({ applyId });
            return draftData;
        },
        getVMPostData() {
        // 在提交时为每个 item 赋上 desc
            this.qualificationList.forEach((qualification) => {
                qualification.items.forEach((item) => {
                    const found = (this.qualificationCertList || []).find((opt) => opt.value === item.qualificationType);
                    item.desc = found ? found.desc : '';
                });
            });
            return this.qualificationList;
        },
        /**
         * 资质逻辑：
         * 1. 城市，加工类型是 成品/原料
         * 2. 根据供应商，生产商唯一确认一个资质，如果生产商不存在，则用供应商
         * 3. 该供应商和生产商 没有不存在已有资质
         */
        genQualificationList(citySaleInfoList) {
            // 全部无资质供应商列表
            // const list = citySaleInfoList.filter((item) => this.judgeSkuTypeIsMaterialOrFinished(item.cityId) && !item.isSupplierExistQualification);
            // if (!list.length) return [];
            // 供应商和生产商唯一去重
            const arr = window._.uniqWith(citySaleInfoList, (val, othval) => `${val.supplierId}${val.manufacturerId || ''}` === `${othval.supplierId}${othval.manufacturerId || ''}`).map((item) => ({
                supplierId: item.supplierId,
                supplierName: item.supplierName,
                manufacturerId: item.manufacturerId,
                manufacturerName: item.manufacturerName,
                items: this.isImportFlag ? importQualificatesTmp() : unImportQualificatesTmp(),
            }));
            return arr;
        },
        // judgeSkuTypeIsMaterialOrFinished(cityId) {
        //     const target = this.createInfoModel.cityIds.find((item) => item === cityId);
        //     if (!target) return '';
        //     // return target.skuType === 1 || target.skuType === 2;
        //     return this.createInfoModel.skuType === 1
        // },
        async validate() {
            if (!this.qualificationList.length) return true;
            let validResult = false;
            try {
                const valids = await Promise.all(this.qualificationList.map((item, idx) => this.$refs[`form-${idx}`][0].validate()));
                validResult = valids.every((valid) => valid === true);
            } catch (error) {
                // 收集主表单校验失败的字段--埋点上报
                const disabledAndValidatedFields = [];
                this.qualificationList.forEach((item, idx) => {
                    if (this.$refs[`form-${idx}`][0].fields && Array.isArray(this.$refs[`form-${idx}`][0].fields)) {
                        this.$refs[`form-${idx}`][0].fields.forEach((field) => {
                            if (field.validateDisabled && field?.validateMessage) {
                                disabledAndValidatedFields.push({
                                    message: field.validateMessage,
                                });
                            }
                        });
                    }
                });
                if (disabledAndValidatedFields.length) {
                    reportMetric('supplier_createNewProduct_disabled_validated_error', 1, {
                        disabledAndValidatedMessages: disabledAndValidatedFields.map((item) => `${item.message}`).join(','),
                        supplierCreateNewProductStepName: CREATE_NEW_PRODUCT_STEP_NAMES[CREATE_NEW_PRODUCT_STEP.SUPPLIER_INFO],
                        createProductType: this.createProductType,
                    });
                }
                // pass
            }
            return validResult;
        },
        //  获取去查看的URL
        getMisRequiredAndDefaultSkuType() {
            const obj = {
                mgCategoryId: this.createInfoModel?.categoryId, // 暂时用管理
                bgCategoryId: this.createInfoModel?.bgCategoryId,
                needQueryField: {
                    requireQualificationSupportUrl: true,
                },
            };
            this.$service.getMisRequired(obj).then((res) => {
                if (res && res.flowSpecByMgCategoryInfo) {
                    this.qualificationSupportUrl = res.flowSpecByMgCategoryInfo.qualificationSupportUrl;
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.supplier-info {
    margin-top: 40px;
    min-height: 500px;
}
.toggle-btn {
    text-align: center;
    cursor: pointer;
}
.max-width {
    max-width: 1200px;
}
/deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #EB2F3C !important;
}
.max-width-750 {
    max-width: 750px;
}
.w-full {
    width: 100%;
}
.view-standard{
    color: #95989e;
    font-size: 12px;
    padding-left: 60px;
}
</style>
